(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kwm-handwerk"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kwm-lazy-video')) {
  customElements.define('kwm-lazy-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.btn = this.querySelector('.kwm-hw__toggle');
      this.mq = window.matchMedia('(max-width: 699px)');
      this.userPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.inView = false;
      if (this.btn) this.btn.addEventListener('click', () => { this.userPaused = !this.userPaused; this.update(); });
      this.mq.addEventListener && this.mq.addEventListener('change', () => { if (this.video.getAttribute('src')) this.load(); this.update(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((e) => { this.inView = e[0].isIntersecting; this.update(); }, { rootMargin: '200px 0px' }).observe(this);
      } else { this.inView = true; this.update(); }
    }
    load() {
      const src = this.mq.matches ? this.dataset.srcMobile : this.dataset.srcDesktop;
      if (this.video.getAttribute('src') !== src) this.video.src = src;
    }
    update() {
      const play = this.inView && !this.userPaused;
      if (play) { this.load(); const p = this.video.play(); if (p && p.catch) p.catch(() => {}); }
      else { this.video.pause(); }
      if (this.btn) { this.btn.classList.toggle('is-paused', !play); this.btn.setAttribute('aria-label', play ? 'Video pausieren' : 'Video abspielen'); }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kwm-instagram"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kwm-lazy-embed')) {
  customElements.define('kwm-lazy-embed', class extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) { window.addEventListener('load', () => this.load()); return; }
      this.io = new IntersectionObserver((e) => { if (e[0].isIntersecting) { this.io.disconnect(); this.load(); } }, { rootMargin: '600px 0px' });
      this.io.observe(this);
    }
    load() {
      if (this.dataset.loaded) return;
      this.dataset.loaded = '1';
      const f = document.createElement('iframe');
      f.src = this.dataset.src; f.title = this.dataset.title; f.className = 'lightwidget-widget';
      f.setAttribute('scrolling', 'no'); f.setAttribute('loading', 'lazy');
      this.appendChild(f);
      if (this.dataset.src.indexOf('lightwidget.com') > -1 && !document.querySelector('script[src*="lightwidget.js"]')) {
        const s = document.createElement('script');
        s.src = 'https://cdn.lightwidget.com/widgets/lightwidget.js'; s.async = true;
        s.onload = () => { this.style.minHeight = ''; };
        document.body.appendChild(s);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kwm-produkt-tabs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kwm-tabs')) {
  customElements.define('kwm-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.allLink = this.querySelector('.kwm-tabs__all');
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(tab));
        tab.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          const next = this.tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length];
          this.select(next); next.focus();
        });
      });
    }
    select(tab) {
      this.tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (this.allLink && tab.dataset.href) this.allLink.href = tab.dataset.href;
      window.dispatchEvent(new Event('resize'));
    }
  });
  document.addEventListener('shopify:block:select', (e) => {
    const tab = document.getElementById('kwm-tab-' + e.detail.blockId);
    if (tab && tab.closest('kwm-tabs')) tab.closest('kwm-tabs').select(tab);
  });
}

  } catch(e) { console.error(e); }
})();
})();
